import React from 'react';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import CheckboxGroup from '@atoms/CheckboxGroup';
import { H5, LinkLarge } from '@styled';

export const messagesSettingsFieldsNotificationsValidationSchema = {
    notifications: Yup.array().nullable(),
};

const MessagesSettingsFieldsNotifications = ({ values, member }) => {
    const isActiveMember = member && member.status?.toUpperCase() === 'ACTIVE' && !member.student && !member.special && !member.prospect;

    return (
        <>
            <H5 className="mt-2 mb-3">Networking Platform Email Notifications</H5>
            {isActiveMember ? (
                <p className="display8 mb-3">
                    I'd like to receive the following notifications for activity via email.
                </p>
            ) : (
                <p className="display8 mb-3">
                    Email digests are only available to active members.{' '}
                    <LinkLarge href="/join/become-a-member">Join today to subscribe.</LinkLarge>
                </p>
            )}
            <CheckboxGroup
                values={values.notifications}
                name="notifications"
                options={[
                    {
                        value: 'WEEKLY',
                        label: 'ICSC Weekly Networking Digest',
                        disabled: !isActiveMember,
                    },
                    {
                        value: 'DAILY',
                        label: 'New Message Notification',
                        disabled: !isActiveMember,
                    },
                ]}
            />
        </>
    );
};

MessagesSettingsFieldsNotifications.propTypes = {
    values: PropTypes.object,
    member: PropTypes.object,
};

export default MessagesSettingsFieldsNotifications;
